import { Reveal } from "@components/ui";

/* ─── Component ─── */

export function RefundsPolicySection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[100px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <Reveal direction="up">
          <div className="rounded-[16px] md:rounded-[24px] bg-gradient-to-br from-[#122d63] to-[#1a3f7a] p-6 md:p-10 lg:p-14 flex flex-col md:flex-row gap-8 md:gap-12 items-start">
            {/* Left */}
            <div className="flex-1">
              <span className="inline-block px-4 py-1.5 rounded-full bg-white/[0.12] text-white text-[13px] font-semibold tracking-[-0.02em] uppercase mb-4">
                Refunds
              </span>
              <h2 className="text-[24px] md:text-[36px] lg:text-[48px] tracking-[-0.04em] font-semibold text-white leading-[1.1] mb-4">
                Refunds Policy
              </h2>
              <p className="text-[14px] md:text-[16px] lg:text-[20px] tracking-[-0.04em] text-white/70 leading-[1.5] max-w-[500px]">
                Overpayment or deposit refunds are handled transparently. Contact our billing team for assistance.
              </p>
            </div>

            {/* Right — refund info */}
            <div className="flex-shrink-0">
              <div className="rounded-[16px] bg-white/10 border border-white/20 p-5 md:p-8">
                <h4 className="text-[16px] md:text-[20px] tracking-[-0.04em] font-semibold text-white font-albert-sans mb-4">
                  Refunds are processed within:
                </h4>
                <div className="flex flex-col gap-3">
                  {[
                    { label: "Overpayment Refund", time: "7–10 working days" },
                    { label: "Security Deposit", time: "7–10 working days" },
                    { label: "Billing Dispute", time: "5–7 working days" },
                  ].map((item) => (
                    <div key={item.label} className="flex items-center justify-between gap-6">
                      <span className="text-[13px] md:text-[16px] text-white/70 font-albert-sans">{item.label}</span>
                      <span className="text-[13px] md:text-[16px] font-semibold text-white font-albert-sans whitespace-nowrap">{item.time}</span>
                    </div>
                  ))}
                </div>
                <p className="mt-4 pt-4 border-t border-white/20 text-[12px] md:text-[14px] text-white/50 font-albert-sans">
                  Contact: help@gasis.ae with account details and proof of payment.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
